import { useMutation, useQueryClient } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import { QueryKey } from "../../constants"
import { Urls } from "../urls"

type Options = {
    conversationId: string
}

export function useEndConversation() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: ({ conversationId }: Options) =>
            axiosClient.post<{ id: number }>(Urls.endConversation(conversationId)),
        onSuccess(_data, variables) {
            queryClient.invalidateQueries({
                queryKey: [QueryKey.SimulabConversation, { id: variables.conversationId }]
            })
        }
    })
}
